export default class LanguageRequestProcessor {
	constructor(settings) {
		this._settings = settings;
	}

	initialize(store){
		this._store = store;
	}

	process(input) {
		let state = this._store.getState();
		let language = state
			[this._settings.stateLocations.Conversation.Base]
			[this._settings.stateLocations.Conversation.language];

	    if (!language) {
	        return Object.assign({}, input);
	    } else {
	        return Object.assign({}, input, { language });
	    }
	}
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/language/src/request-processor-language.js